var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 12",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.464.364L6.716 9.182 2.382 6.077a1.24 1.24 0 00-1.719.272 1.21 1.21 0 00.276 1.7l5.192 3.72c.217.155.47.231.722.231.32 0 .64-.123.878-.364L17.22 2.07c.476-.48.47-1.25-.017-1.722a1.24 1.24 0 00-1.74.016z",
    fill: "currentColor"
  })));
}

export default SvgTick;